import { styled, Text, spacing, mq } from '@thg-commerce/gravity-theme'
import {
  Button,
  ProductImage,
  ErrorMessage,
} from '@thg-commerce/gravity-elements'

import { PageMessage } from '../PageMessage'

export const ModalTitle = styled.h2`
  ${Text('large1', 'alternate')};
  width: 100%;
  display: block;
  text-align: left;
  margin-bottom: ${spacing(2)};
`

export const StyledErrorMessage = styled(ErrorMessage)`
  margin-bottom: ${spacing(4)};
`

export const ProductTitle = styled.h3<{ reducedBottomMargin: boolean }>`
  ${Text('large1', 'alternate')};
  width: 100%;
  display: block;
  text-align: left;
  margin-top: ${spacing(2)};
  margin-bottom: ${(props) => spacing(props.reducedBottomMargin ? 2 : 3)};

  ${({ theme }) => mq(theme.breakpointUtils.map, 'md')} {
    margin-bottom: ${spacing(2)};
    margin-top: 0;
  }
`
export const ProductTagsContainer = styled.div`
  margin-bottom: ${spacing(2)};
`

export const ModalContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${({ theme }) => mq(theme.breakpointUtils.map, 'md')} {
    flex-direction: row;
  }
`

export const ContentContainer = styled.div`
  flex-grow: 1;

  ${({ theme }) => mq(theme.breakpointUtils.map, 'md')} {
    margin-left: ${spacing(4)};
  }
`

export const PricingSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing(2)};
`

export const AvailabilityMessage = styled.div`
  ${Text('small', 'default')};
  color: ${({ theme }) => theme.colors.palette.greys.dark};
  margin-bottom: ${spacing(3)};
`

export const AddToBasketButton = styled(Button)`
  width: 100%;
  margin-bottom: ${spacing(2)};
`

export const ViewInfoButton = styled(Button)`
  width: 100%;
`

export const StyledProductImage = styled(ProductImage)`
  flex-shrink: 0;
`

export const StyledPageMessage = styled(PageMessage)`
  margin-bottom: ${spacing(4)};
`
